const Audio = (props) => <audio {...props} data-testid={props['data-testid']} />;

export default Audio;
